module.exports = __webpack_public_path__ + "img/cinema_curtains_3.db8f0b4f.png";